var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M10.24,1.76A6,6,0,1,0,11.8,7.5H10.24A4.5,4.5,0,1,1,6,1.5,4.43,4.43,0,0,1,9.16,2.84L6.75,5.25H12V0Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }